import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { AllPatient } from 'src/app/models/patient';
import { Utils } from 'src/app/common/utils';



@Component({
  selector: 'app-patient-members',
  templateUrl: './patient-members.component.html',
  styleUrls: ['./patient-members.component.css']
})
export class PatientMembersComponent implements OnInit {
  @ViewChild('confirmRequestModal', { static: true } as any) confirmRequestModal: TemplateRef<any>;

  profiles: AllPatient;
  relation = Utils.RELATION;
  constructor(private modal: NgbModal, private service: VproService, private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit() {

    this.getPatient();
  }

  confirmRequest(): void {
    this.modal.open(this.confirmRequestModal)
  }


  getPatient() {
    this.spinner.show();
    this.service.getPatientById(localStorage.getItem("uid"), '?fields=members').subscribe(res => {
      this.spinner.hide();
      this.profiles = res;

      if (this.profiles && this.profiles.members) {
        for (let member of this.profiles.members) {
          if (member && member.relation)
            member.relation = this.relationValue(member.relation);
        }
      }
    }, err => {
      this.spinner.hide();
    });
  }

  relationValue(relatioship) {
    for (let r of this.relation) {
      if (r.value === relatioship) {
        relatioship = r.key;
        return relatioship;
      }
    }
  }

}
